import WhySol from "../components/WhySol";
import TrustBar from "../components/TrustBar";
import Reveal from "../components/Reveal";
import { Squiggle, Star } from "../components/Illustrations";

export default function WhySolPage() {
  return (
    <div className="pt-28" data-testid="why-sol-page">
      <section className="px-5 md:px-10 pb-12">
        <div className="mx-auto max-w-[1100px] text-center">
          <Reveal><p className="eyebrow mb-4">Why SOL</p></Reveal>
          <Reveal delay={60}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[112px] leading-[0.95] tracking-[-0.03em] max-w-[20ch] mx-auto">
              Made for the way <span className="italic">kids actually play.</span>
            </h1>
          </Reveal>
          <Reveal delay={140}>
            <Squiggle w={140} className="mx-auto opacity-60 mt-8" />
          </Reveal>
        </div>
      </section>
      <TrustBar />
      <WhySol />
      <section className="px-5 md:px-10 py-24 bg-[#F3EADA]">
        <div className="mx-auto max-w-[1100px] text-center">
          <Star className="mx-auto wiggle mb-4" size={28} color="#F2D06B" />
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-[-0.025em] max-w-[24ch] mx-auto">
            Designed for Indian kids, <span className="italic">obsessed over by Indian parents.</span>
          </h2>
        </div>
      </section>
    </div>
  );
}
